<!-- TOP BAR -->
<div class="top-bar">
  <!-- <button class="back-btn" (click)="goBack()" aria-label="Back to product library">
      <span class="icon">‹</span> Back
    </button> -->
    <div style="display: flex;
    gap: 10px;">
    <button
      mat-icon-button
      matTooltip="Back"
      style="    width: fit-content;
    height: fit-content;
    line-height: normal;"
    (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
  </div>
  <div class="product-type">
    <span>Study</span> :
  </div>
  <div class="top-right">
    <div class="info-title">
      {{  study?.name__v ||"—" }}
    </div>
    <!-- <div class="info-sub">Product ID: <strong>{{ product?.id }}</strong></div> -->
  </div>
</div>

<!-- PAGE LAYOUT -->
<div class="page-layout">
  <!-- SIDEBAR -->
  <!-- <aside class="sidebar" role="navigation" aria-label="Product sections">
    <h4 class="side-title">Sections</h4>
    <ul class="side-menu">
      <li
        *ngFor="let s of sections"
        (click)="scrollToSection(s.key)"
        [class.active]="activeSection === s.key"
        role="button"
        tabindex="0"
      >
        <span class="sm-text">{{ s.title }}</span>
      </li>
    </ul>
  </aside> -->

  <!-- MAIN CONTENT -->
  <main class="content" #mainContent>
    <section *ngFor="let s of sections" class="section-box" [id]="s.key">
      <button
        class="section-header"
        (click)="toggleSection(s.key)"
        [attr.aria-expanded]="sectionVisibility[s.key]"
      >
        <div class="header-left">
          <span class="section-icon" [class.rotated]="sectionVisibility[s.key]"
            >▼</span
          >
          <div class="header-title">{{ s.title }}</div>
        </div>
      </button>

      <div class="section-content" *ngIf="sectionVisibility[s.key]">
        <div class="form-grid">
          <!-- Use dynamic content for each section -->
          <ng-container [ngSwitch]="s.key">
            <!-- details Info -->
            <ng-container *ngSwitchCase="'details'">
              <div class="generalform-grid">
              <mat-form-field appearance="outline">
                <mat-label>Organization</mat-label>
                <input
                  matInput
                  [value]="study?.organization__v_name__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Study Number</mat-label>
                <input
                  matInput
                  [value]="study?.id || '–' "
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Study Type</mat-label>
                <input
                  matInput
                  [value]="study?.study_type__v_name__v || '–'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Study Name</mat-label>
                <textarea
                  matInput
                  [value]="study?.name__v || '–'"
                  readonly
                >
                </textarea>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Development Phase </mat-label>
                <input
                  matInput
                  [value]="study?.development_phase__v || '–'" 
                  readonly
                />
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Study Has Arms</mat-label>
                <input
                  matInput
                  [value]="study?.study_has_arms__v || '–'"
                  readonly
                />
              </mat-form-field>
              </div>
            </ng-container>

            <!-- studyProduct INFO -->
            <ng-container *ngSwitchCase="'studyProduct'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="studyProductColumnDefs"
                [rowData]="studyProductData"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onstudyProductGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>
            </ng-container>

                <!-- studyArm -->
                <ng-container *ngSwitchCase="'studyArm'">
                
                <!--Create Button -->
                <!-- <div class="grid-header">
                     <button id="saveBtn" i18n="@@TMRunButton" type="button" (click)="onCreateStudyArm()" [style.background-color]="backgroundColorButton"
                  class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding: .3rem 1.6rem;">Create</button>
                </div> -->

                <!-- AG Grid -->
                <ag-grid-angular
                    class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass thin"
                    style="width: 100%; height: 320px"
                    [columnDefs]="studyArmColumnDefs"
                    [rowData]="studyArmRowData"
                    [animateRows]="true"
                    [pagination]="true"
                    [defaultColDef]="defaultColDef"
                    [paginationPageSize]="3"
                    (gridReady)="onstudyArmGridReady($event)"
                    [gridOptions]="gridOptions"
                    [enableBrowserTooltips]="true"
                >
                </ag-grid-angular>

                </ng-container>


            <!-- indication -->
            <ng-container *ngSwitchCase="'indication'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="indicationColumnDefs"
                [rowData]="indicationRowData"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onindicationGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>
            </ng-container>

         <!-- study Registration -->
            <ng-container *ngSwitchCase="'Registration'">
              <ag-grid-angular
                class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                style="width: 100%; height: 320px"
                [columnDefs]="RegistrationColumnDefs"
                [rowData]="RegistrationRowData"
                [animateRows]="true"
                [pagination]="true"
                [defaultColDef]="defaultColDef"
                [paginationPageSize]="3"
                [animateRows]="true"
                (gridReady)="onRegistrationGridReady($event)"
                [gridOptions]="gridOptions"
                [enableBrowserTooltips]="true"
              ></ag-grid-angular>

            </ng-container>

          </ng-container>
        </div>
      </div>
    </section>
  </main>
</div>
